import React, { ReactElement } from 'react';
import { ScreenType, SelectScreenConfig } from '../../config/FlowTypes';
import { ScreenWrapper } from '../styles/Containers';
import { NavigationProps } from './FlowNavigation';
import { SELECT_DELAY_DEFAULT_MS } from './SingleSelectDefaultDelay';
import { onSingleSelectSubmit } from './SingleSelectScreen';
import {
  NumberedSingleSelectLayout,
  NumberedSingleSelectLayoutConfig,
} from './layouts/NumberedSingleSelectLayout';

export type NumberedSingleSelectScreenConfig<ScreenNames extends string> = SelectScreenConfig<
  ScreenType.NumberedSingleSelect,
  NumberedSingleSelectLayoutConfig,
  ScreenNames
> & { delayInMsBetweenClickAndNavigate?: number };

type Props<ScreenNames extends string> = NavigationProps<
  NumberedSingleSelectScreenConfig<ScreenNames>,
  ScreenNames
>;

/** Shares {@link onSingleSelectSubmit} with {@link SingleSelectScreen} while omitting PHI answers from analytics. */
export const NumberedSingleSelectScreen = <ScreenNames extends string>(
  props: Props<ScreenNames>
): ReactElement => {
  const delayInMsBetweenClickAndNavigate =
    props.delayInMsBetweenClickAndNavigate ?? SELECT_DELAY_DEFAULT_MS;

  function onSelected(selected: string) {
    setTimeout(
      () => onSingleSelectSubmit({ props, selected, isPHI: true }),
      delayInMsBetweenClickAndNavigate
    );
  }

  return (
    <ScreenWrapper>
      <NumberedSingleSelectLayout
        {...props.layout}
        onSelected={onSelected}
        onShowToast={props.onShowToast}
      />
    </ScreenWrapper>
  );
};
